
<template>
    <div  class="model-dialog">
        <el-dialog
            :title="title"
            :visible.sync="show"
            :width='width'
            :before-close="handleClose">
            <slot name="content"></slot>
            <span slot="footer" class="dialog-footer">
                <el-button @click.native="onClick('cancel',$event)" v-if='cancel'  class="cancel-btn">{{cancel}}</el-button>
                <el-button @click.native="onClick('ok',$event)" v-if='ok' type="primary" class="medical-btn">{{ok}}</el-button>
            </span>
        </el-dialog>
    </div>
    
</template>

<script>
export default {
    props:{
        cancel:{
            type: String,
        },
        ok:{
            type: String,
        },
        show:{
            type: Boolean,
        },
        width:{
            type: String,
            default:'340px'
        },
        title:{
            type: String,
            default:'提示'
        }
    },
    data() {
      return {
        //add_dialogVisible: true
      };
    },
    methods: {
        
        onClick (msg,e) {
            if(msg=='cancel'){
                this.$emit('update:show',false)
            }else{
                this.$emit(msg,e);
            }
            
        },
        handleClose() {
            this.$emit('update:show',false)
            // this.$emit('cancel');
        },
    }
  };
</script>
    
<style lang='less' scoped>
.model-dialog{
    ::v-deep .el-dialog__header{
        line-height: 24px; 
        font-size: 18px;
        padding: 10px 20px;
        // .el-dialog__title{
        //     color: #fff;
        // }
    }
    ::v-deep  .el-dialog__header{
        line-height: 24px; 
        font-size: 18px;
        padding: 10px 20px;
        // .el-dialog__title{
        //     color: #fff;
        // }
    }

    ::v-deep .el-dialog__headerbtn{
        top:12px;
        // .el-dialog__close{
        //     color: #fff !important;
        // }
    } 
    ::v-deep .el-dialog__body{
        padding: 20px !important;
    }
    ::v-deep .el-dialog__footer{
        padding-top: 0;
    }
}
</style>